import { SlackPushTypes } from '@notifications/entities/push-types';

export type SlackPushPayload = Readonly<{
  source: string,
  type: SlackPushTypes,
  message: SlackPushMessage,
  priority: number,
}>;

export type SlackPushMessage = Readonly<{
  blocks: SlackPushMessageBlock[]
}>;

export type SlackPushMessageBlock = Readonly<{
  type: MessageBlockType,
  text?: SlackPushMessageBlockText,
  elements?: SlackPushMessageBlockText[]
}>;


export type SlackPushMessageBlockText = Readonly<{
  text: string,
  type: MessageBlockTextType,
}>;

export type SlackPushResponse = Readonly<{

}>;

export enum MessageBlockType {
  Section = 'section',
  Divider = 'divider',
  Header = 'header',
  Context = 'context',
}

export enum MessageBlockTextType {
  Markdown = 'mrkdwn',
  String = 'string',
  Plaintext = 'plain_text',
}
